var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "carousel-container" }, [
    _c("div", { staticClass: "carousel-inner centered" }, [
      _c(
        "div",
        { staticClass: "track centered" },
        _vm._l(_vm.cards, function(card) {
          return _c(
            "div",
            { key: _vm.cards[card], staticClass: "card-container centered" },
            [
              _c("neu-card-general", {
                attrs: {
                  "data-index": _vm.index,
                  src: card.src,
                  link: card.link,
                  title: card.title,
                  subtitle: card.subtitle,
                  titleLines: card.titleLines,
                  subtitleLines: card.subtitleLines,
                  iconColor: _vm.iconColor
                }
              })
            ],
            1
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "nav centered" }, [
      _c(
        "button",
        {
          staticClass: "prev",
          staticStyle: {
            "background-color": "transparent",
            "border-color": "transparent",
            transform: "rotate(-180deg)"
          }
        },
        [
          _c(
            "i",
            { staticClass: "prev" },
            [
              _c("base-icon", {
                staticClass: "prev",
                attrs: {
                  width: "30",
                  height: "30",
                  src: "/static-appopensalud/img/icons/noun-arrow-blue.svg",
                  color: _vm.iconColor
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "next",
          staticStyle: {
            "background-color": "transparent",
            "border-color": "transparent",
            transform: "rotate(-0deg)"
          }
        },
        [
          _c(
            "i",
            { staticClass: "next" },
            [
              _c("base-icon", {
                staticClass: "next",
                attrs: {
                  width: "30",
                  height: "30",
                  src: "/static-appopensalud/img/icons/noun-arrow-blue.svg",
                  color: _vm.iconColor
                }
              })
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-681f3a61", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-681f3a61","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/carousel/Carousel2.vue
// module id = 3680
// module chunks = 149